import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import WhatIfCompareViewTableDto from '../dto/WhatIfCompareViewTableDto';

class WhatIfCompareViewTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'whatIfCompareViewTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<WhatIfCompareViewTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, WhatIfCompareViewTableDto)))
				.catch(reject);
		});
	}
}

export default new WhatIfCompareViewTableService();
